import { useQuery } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { Box } from 'styled-system/jsx';

import LoadingPage from '@/common/pages/LoadingPage';
import { FileTypeConst } from '@/common/types/Files.type';
import DelayAlert from '@/modules/FileDetail/components/renderAlert/alerts/DelayAlert.tsx';
import FileDetailOfflineAlert from '@/modules/OfflineFiles/components/Alert/FileDetailOfflineAlert';
import ReasonAlert from '@/modules/FileDetail/components/renderAlert/alerts/ReasonAlert.tsx';
import {
  delayAlertType,
  reasonAlertType,
} from '@/modules/FileDetail/queries/alerts/alertsQuery.type.ts';
import { alertsQueryOptions } from '@/modules/FileDetail/queries/alerts/alertsQueryOptions.ts';
import { useParams } from 'react-router-dom';

const RenderAlert = ({ fileType }: { fileType: FileTypeConst }) => {
  const { id } = useParams();

  const { data, isPending, isError } = useQuery(alertsQueryOptions(id!));
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }
  if (data?.has_alert) {
    return (
      <Box mt="16px">
        {data?.delay_alert?.map((item) => (
          <Box key={item.type}>{renderDelayAlert(item)}</Box>
        ))}
        {data?.reason_alert?.map((item) => (
          <Box key={item.type}>{renderReasonAlert(item)}</Box>
        ))}
        {data?.has_offline ? (
          <FileDetailOfflineAlert fileType={fileType} />
        ) : null}
      </Box>
    );
  } else return <></>;
};
export default RenderAlert;

const renderDelayAlert = (delayAlertItem: delayAlertType) => {
  const items: Record<string, ReactNode> = {
    send_adjusting_report: <DelayAlert delayAlertItem={delayAlertItem} />,
    define_adjusting_datetime: <DelayAlert delayAlertItem={delayAlertItem} />,
  };
  return items[delayAlertItem.type];
};

const renderReasonAlert = (reasonAlertItem: reasonAlertType) => {
  const items: Record<string, ReactNode> = {
    need_to_edit_reports: <ReasonAlert reasonAlertItem={reasonAlertItem} />,
    archived: <ReasonAlert reasonAlertItem={reasonAlertItem} />,
    refer_to_branch: <ReasonAlert reasonAlertItem={reasonAlertItem} />,
  };
  return items[reasonAlertItem.type];
};
